import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const user = localStorage.getItem('user');
  const token = localStorage.getItem('token');
  // Une session sans token (ex : connexion antérieure au passage au JWT) doit
  // repasser par la connexion : les endpoints protégés exigent le token.
  if (!user || !token) return <Navigate to="/auth" replace />;
  return children;
};

export default ProtectedRoute;
